import React, { Component } from 'react'

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import NumberMaskInput from 'components/CustomInput/NumberMaskInput';
import ButtonGroupSelect from 'components/Select/ButtonGroupSelect';

import Api from 'api/index.js';
import ProvisioningEndpoints from 'api/ProvisioningEndpoints';

const transaction = "transaction";
const subscription = "subscription";

class AddBulkModal extends Component {

    constructor(props) {
        super(props)

    }

    state = {
        loading: false,

        bill_cycle: transaction,

        price: 0,
        priceFormatted: '',
        priceState: '',

        reference: '',
        referenceState: ''
    }

    changeNum(e, name) {
        this.setState({ [name]: e.target.floatValue, [name + "Formatted"]: e.target.formattedValue, [name + "State"]: (e.target.formattedValue ? "success" : "error") });
    }

    submit = () => {
        Api.post(ProvisioningEndpoints.addBulk,
            {
                ...this.state,
                product_id: this.props.product_id,
                account_id: this.props.customer_id,
                service_ids: this.props.service_ids
            }
        )
            .then(({ data }) => {
                console.log(data);
                if (this.props.refresh) {
                    this.props.refresh();
                    this.props.close();
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    render() {

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Add Pricing for All Services</DialogTitle>
                <DialogContent style={{ textAlign: 'center', overflow: 'visible' }}>

                    <ButtonGroupSelect
                        options={[transaction, subscription]}//, adhoc
                        value={this.state.bill_cycle}
                        onChange={(val) => this.setState({ bill_cycle: val })}
                    />

                    <NumberMaskInput
                        success={this.state.priceState === "success"}
                        error={this.state.priceState === "error"}
                        labelText={
                            <span>
                                Price <small>(required)</small>
                            </span>
                        }
                        id="price"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.changeNum(event, 'price'),
                            value: this.state.priceFormatted
                        }}
                    />

                    <CustomInput
                        success={this.state.referenceState === "success"}
                        error={this.state.referenceState === "error"}
                        labelText={
                            <span>
                                Reference <small>(required)</small>
                            </span>
                        }
                        id="reference"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.setState({ reference: event.target.value, referenceState: (event.target.value ? "success" : "error") }),
                            value: this.state.reference
                        }}
                    />

                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>

                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Save Changes
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(extendedFormsStyle)(AddBulkModal);